import { useRef, useState } from "react";
import { Download, ChevronDown, Upload } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import {
  exportManualFlights,
  exportTemplateManualFlights,
  importManualFlightsCsv,
} from "../../api/ManualFlightsApi";
type Props = {
  onOpenChange: (open: boolean) => void;
};
export function ManualFlightsHeader({ onOpenChange }: Props) {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isImporting, setIsImporting] = useState(false);

  const handleDownloadTemplate = () => {
    const headers =
      "Flight Code,Departure Date,Route,Airline,Price,Currency,Seats,Status";
    const example =
      "DV 013,2026-06-22,SSH - NQZ,SCAT Airlines,56000.00,KZT,4,active";

    const csvContent =
      "data:text/csv;charset=utf-8," + headers + "\n" + example + "\n";

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "manual_flights_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // чтобы можно было выбрать тот же файл повторно
    e.target.value = "";

    if (!file.name.toLowerCase().endsWith(".csv")) {
      // тут можно заменить на ваш toast
      alert("Нужен CSV файл (.csv)");
      return;
    }

    try {
      setIsImporting(true);
      await importManualFlightsCsv(file);
      // тут можно: refetch списка рейсов
      // onImported?.()
    } catch (err) {
      console.error(err);
      alert("Не удалось импортировать CSV");
    } finally {
      setIsImporting(false);
    }
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-3xl font-bold">Добавить ручные рейсы</h1>

      {/* скрытый input */}
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv,text/csv"
        className="hidden"
        onChange={onFileChange}
      />
      <div className="flex gap-3">
        <Button
          variant="outline"
          className="gap-2"
          disabled={isImporting}
          onClick={exportManualFlights}
        >
          <Download className="w-4 h-4 mr-2" />
          Экспорт таблицы
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="gap-2" disabled={isImporting}>
              {isImporting ? "Импорт..." : "Импорт таблицы"}
              <ChevronDown className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>

          <DropdownMenuContent align="end">
            <DropdownMenuItem
              onClick={() => onOpenChange(true)}
              disabled={isImporting}
            >
              <Upload className="w-4 h-4 mr-2" />
              Загрузить CSV
            </DropdownMenuItem>

            <DropdownMenuItem onClick={exportTemplateManualFlights}>
              <Download className="w-4 h-4 mr-2" />
              Скачать шаблон CSV
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
